import * as Types from '../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ChatAttachMenuLibraryItemsQueryVariables = Types.Exact<{
  input: Types.AdminLibraryInput;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type ChatAttachMenuLibraryItemsQuery = { __typename?: 'Query', AdminLibrary: { __typename?: 'LibraryItems', objects: Array<{ __typename?: 'LibraryItem', id: string, type: Types.LibraryItemType, name: { __typename?: 'TranslationSet', en: string }, coverImage?: { __typename?: 'CoverImage', id: string, emojiIcon?: string | null, background?: Types.BackgroundGradient | null, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, thumb?: string | null } | null } | null, trainingResource?: { __typename?: 'TrainingResource', id: string, draftVersion: { __typename?: 'TrainingResourceVersion', id: string, type: Types.TrainingResourceVersionType, media?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, thumb?: string | null } | null } | null }, publishedVersion?: { __typename?: 'TrainingResourceVersion', id: string, type: Types.TrainingResourceVersionType, media?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, thumb?: string | null } | null } | null } | null } | null }> } };

export type ChatAttachmentLibraryItemFragment = { __typename?: 'LibraryItem', id: string, type: Types.LibraryItemType, name: { __typename?: 'TranslationSet', en: string }, coverImage?: { __typename?: 'CoverImage', id: string, emojiIcon?: string | null, background?: Types.BackgroundGradient | null, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, thumb?: string | null } | null } | null, trainingResource?: { __typename?: 'TrainingResource', id: string, draftVersion: { __typename?: 'TrainingResourceVersion', id: string, type: Types.TrainingResourceVersionType, media?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, thumb?: string | null } | null } | null }, publishedVersion?: { __typename?: 'TrainingResourceVersion', id: string, type: Types.TrainingResourceVersionType, media?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, thumb?: string | null } | null } | null } | null } | null };

export type ChatAttachment_TrainingResourceVersionFragment = { __typename?: 'TrainingResourceVersion', id: string, type: Types.TrainingResourceVersionType, media?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, thumb?: string | null } | null } | null };

export type ChatAttachmentMediaFragment = { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, thumb?: string | null } | null };

export type VercelAiChatAnnotationFragment = { __typename?: 'VercelAiChatAnnotation', type: string, file_id?: string | null, filename?: string | null, quote?: string | null, index?: number | null, metadata?: { [key: string]: any } | null };

export type VercelAiChatMessageFragment = { __typename?: 'VercelAiChatMessage', id: string, role: Types.VercelAiChatMessageRole, content: string, createdAt: string, annotations?: Array<{ __typename?: 'VercelAiChatAnnotation', type: string, file_id?: string | null, filename?: string | null, quote?: string | null, index?: number | null, metadata?: { [key: string]: any } | null }> | null };

export type AiExchangeAttachmentFragment = { __typename?: 'AiExchangeAttachment', id: string, libraryItem: { __typename?: 'LibraryItem', id: string, type: Types.LibraryItemType, name: { __typename?: 'TranslationSet', en: string }, coverImage?: { __typename?: 'CoverImage', id: string, emojiIcon?: string | null, background?: Types.BackgroundGradient | null, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, thumb?: string | null } | null } | null, trainingResource?: { __typename?: 'TrainingResource', id: string, draftVersion: { __typename?: 'TrainingResourceVersion', id: string, type: Types.TrainingResourceVersionType, media?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, thumb?: string | null } | null } | null }, publishedVersion?: { __typename?: 'TrainingResourceVersion', id: string, type: Types.TrainingResourceVersionType, media?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, thumb?: string | null } | null } | null } | null } | null }, media: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, thumb?: string | null } | null } };

export type AiChatExchangeFragment = { __typename?: 'AiChatExchange', id: string, createdAt: string, attachments: Array<{ __typename?: 'AiExchangeAttachment', id: string, libraryItem: { __typename?: 'LibraryItem', id: string, type: Types.LibraryItemType, name: { __typename?: 'TranslationSet', en: string }, coverImage?: { __typename?: 'CoverImage', id: string, emojiIcon?: string | null, background?: Types.BackgroundGradient | null, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, thumb?: string | null } | null } | null, trainingResource?: { __typename?: 'TrainingResource', id: string, draftVersion: { __typename?: 'TrainingResourceVersion', id: string, type: Types.TrainingResourceVersionType, media?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, thumb?: string | null } | null } | null }, publishedVersion?: { __typename?: 'TrainingResourceVersion', id: string, type: Types.TrainingResourceVersionType, media?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, thumb?: string | null } | null } | null } | null } | null }, media: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, thumb?: string | null } | null } }>, vercelChatMessages: Array<{ __typename?: 'VercelAiChatMessage', id: string, role: Types.VercelAiChatMessageRole, content: string, createdAt: string, annotations?: Array<{ __typename?: 'VercelAiChatAnnotation', type: string, file_id?: string | null, filename?: string | null, quote?: string | null, index?: number | null, metadata?: { [key: string]: any } | null }> | null }> };

export type AiChatFragment = { __typename?: 'AiChat', id: string, title: string, createdAt: string, type: Types.AiChatType, exchanges: Array<{ __typename?: 'AiChatExchange', id: string, createdAt: string, attachments: Array<{ __typename?: 'AiExchangeAttachment', id: string, libraryItem: { __typename?: 'LibraryItem', id: string, type: Types.LibraryItemType, name: { __typename?: 'TranslationSet', en: string }, coverImage?: { __typename?: 'CoverImage', id: string, emojiIcon?: string | null, background?: Types.BackgroundGradient | null, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, thumb?: string | null } | null } | null, trainingResource?: { __typename?: 'TrainingResource', id: string, draftVersion: { __typename?: 'TrainingResourceVersion', id: string, type: Types.TrainingResourceVersionType, media?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, thumb?: string | null } | null } | null }, publishedVersion?: { __typename?: 'TrainingResourceVersion', id: string, type: Types.TrainingResourceVersionType, media?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, thumb?: string | null } | null } | null } | null } | null }, media: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, thumb?: string | null } | null } }>, vercelChatMessages: Array<{ __typename?: 'VercelAiChatMessage', id: string, role: Types.VercelAiChatMessageRole, content: string, createdAt: string, annotations?: Array<{ __typename?: 'VercelAiChatAnnotation', type: string, file_id?: string | null, filename?: string | null, quote?: string | null, index?: number | null, metadata?: { [key: string]: any } | null }> | null }> }> };

export type ChatHistoryQueryVariables = Types.Exact<{
  input: Types.MyAiChatsInput;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type ChatHistoryQuery = { __typename?: 'Query', MyAiChats: { __typename?: 'AiChats', totalCount: number, objects: Array<{ __typename?: 'AiChat', id: string, title: string, createdAt: string, type: Types.AiChatType, exchanges: Array<{ __typename?: 'AiChatExchange', id: string, createdAt: string, attachments: Array<{ __typename?: 'AiExchangeAttachment', id: string, libraryItem: { __typename?: 'LibraryItem', id: string, type: Types.LibraryItemType, name: { __typename?: 'TranslationSet', en: string }, coverImage?: { __typename?: 'CoverImage', id: string, emojiIcon?: string | null, background?: Types.BackgroundGradient | null, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, thumb?: string | null } | null } | null, trainingResource?: { __typename?: 'TrainingResource', id: string, draftVersion: { __typename?: 'TrainingResourceVersion', id: string, type: Types.TrainingResourceVersionType, media?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, thumb?: string | null } | null } | null }, publishedVersion?: { __typename?: 'TrainingResourceVersion', id: string, type: Types.TrainingResourceVersionType, media?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, thumb?: string | null } | null } | null } | null } | null }, media: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, thumb?: string | null } | null } }>, vercelChatMessages: Array<{ __typename?: 'VercelAiChatMessage', id: string, role: Types.VercelAiChatMessageRole, content: string, createdAt: string, annotations?: Array<{ __typename?: 'VercelAiChatAnnotation', type: string, file_id?: string | null, filename?: string | null, quote?: string | null, index?: number | null, metadata?: { [key: string]: any } | null }> | null }> }> }> } };

export type GenCourseFromOutlineChatMutationVariables = Types.Exact<{
  input: Types.GenCourseFromOutlineChatInput;
}>;


export type GenCourseFromOutlineChatMutation = { __typename?: 'Mutation', genCourseFromOutlineChat: { __typename?: 'CourseMutationResult', success: boolean, error?: { __typename?: 'Error', code: string } | null, course?: { __typename?: 'Course', id: number, draftVersion: { __typename?: 'CourseVersion', id: number }, libraryItem: { __typename?: 'LibraryItem', id: string } } | null } };

export type StartGenCourseFromOutlineChatWorkflowMutationVariables = Types.Exact<{
  input: Types.GenCourseFromOutlineChatInput;
}>;


export type StartGenCourseFromOutlineChatWorkflowMutation = { __typename?: 'Mutation', startGenCourseFromOutlineChatWorkflow: { __typename?: 'ClientFacingWorkflowMutationResult', success: boolean, error?: { __typename?: 'Error', code: string } | null, clientFacingWorkflow?: { __typename?: 'ClientFacingWorkflow', id: string, type: Types.ClientFacingWorkflowType, status: Types.ClientFacingWorkflowStatus, createdAt: string, result?: { __typename?: 'ClientFacingWorkflowResult', id: string, libraryItem?: { __typename?: 'LibraryItem', id: string, name: { __typename?: 'TranslationSet', uuid: string, en: string } } | null } | null } | null } };

export type StartGenModuleFromOutlineChatWorkflowMutationVariables = Types.Exact<{
  input: Types.GenModuleFromOutlineChatInput;
}>;


export type StartGenModuleFromOutlineChatWorkflowMutation = { __typename?: 'Mutation', startGenModuleFromOutlineChatWorkflow: { __typename?: 'ClientFacingWorkflowMutationResult', success: boolean, error?: { __typename?: 'Error', code: string } | null, clientFacingWorkflow?: { __typename?: 'ClientFacingWorkflow', id: string, type: Types.ClientFacingWorkflowType, status: Types.ClientFacingWorkflowStatus, createdAt: string, result?: { __typename?: 'ClientFacingWorkflowResult', id: string, libraryItem?: { __typename?: 'LibraryItem', id: string, name: { __typename?: 'TranslationSet', uuid: string, en: string } } | null } | null } | null } };

export type StartGenTaskListFromOutlineChatWorkflowMutationVariables = Types.Exact<{
  input: Types.GenTaskListFromOutlineChatInput;
}>;


export type StartGenTaskListFromOutlineChatWorkflowMutation = { __typename?: 'Mutation', startGenTaskListFromOutlineChatWorkflow: { __typename?: 'ClientFacingWorkflowMutationResult', success: boolean, error?: { __typename?: 'Error', code: string } | null, clientFacingWorkflow?: { __typename?: 'ClientFacingWorkflow', id: string, type: Types.ClientFacingWorkflowType, status: Types.ClientFacingWorkflowStatus, createdAt: string, result?: { __typename?: 'ClientFacingWorkflowResult', id: string, libraryItem?: { __typename?: 'LibraryItem', id: string, name: { __typename?: 'TranslationSet', uuid: string, en: string } } | null } | null } | null } };

export type StartGenCheckInFromOutlineChatWorkflowMutationVariables = Types.Exact<{
  input: Types.GenCheckInFromOutlineChatInput;
}>;


export type StartGenCheckInFromOutlineChatWorkflowMutation = { __typename?: 'Mutation', startGenCheckInFromOutlineChatWorkflow: { __typename?: 'ClientFacingWorkflowMutationResult', success: boolean, error?: { __typename?: 'Error', code: string } | null, clientFacingWorkflow?: { __typename?: 'ClientFacingWorkflow', id: string, type: Types.ClientFacingWorkflowType, status: Types.ClientFacingWorkflowStatus, createdAt: string, result?: { __typename?: 'ClientFacingWorkflowResult', id: string, libraryItem?: { __typename?: 'LibraryItem', id: string, name: { __typename?: 'TranslationSet', uuid: string, en: string } } | null } | null } | null } };

export type StartGenAuditFromOutlineChatWorkflowMutationVariables = Types.Exact<{
  input: Types.GenAuditFromOutlineChatInput;
}>;


export type StartGenAuditFromOutlineChatWorkflowMutation = { __typename?: 'Mutation', startGenAuditFromOutlineChatWorkflow: { __typename?: 'ClientFacingWorkflowMutationResult', success: boolean, error?: { __typename?: 'Error', code: string } | null, clientFacingWorkflow?: { __typename?: 'ClientFacingWorkflow', id: string, type: Types.ClientFacingWorkflowType, status: Types.ClientFacingWorkflowStatus, createdAt: string, result?: { __typename?: 'ClientFacingWorkflowResult', id: string, libraryItem?: { __typename?: 'LibraryItem', id: string, name: { __typename?: 'TranslationSet', uuid: string, en: string } } | null } | null } | null } };

export const ChatAttachmentMediaFragmentDoc = gql`
    fragment ChatAttachmentMedia on Media {
  id
  thumbnailImageUrl
  mediaUrls {
    uuid
    en
  }
  imageUrls {
    id
    original
    thumb
  }
}
    `;
export const ChatAttachment_TrainingResourceVersionFragmentDoc = gql`
    fragment ChatAttachment_TrainingResourceVersion on TrainingResourceVersion {
  id
  type
  media {
    ...ChatAttachmentMedia
  }
}
    ${ChatAttachmentMediaFragmentDoc}`;
export const ChatAttachmentLibraryItemFragmentDoc = gql`
    fragment ChatAttachmentLibraryItem on LibraryItem {
  id
  type
  name {
    en
  }
  coverImage {
    id
    emojiIcon
    background
    imageUrls {
      id
      original
      thumb
    }
  }
  trainingResource {
    id
    draftVersion {
      ...ChatAttachment_TrainingResourceVersion
    }
    publishedVersion {
      ...ChatAttachment_TrainingResourceVersion
    }
  }
}
    ${ChatAttachment_TrainingResourceVersionFragmentDoc}`;
export const AiExchangeAttachmentFragmentDoc = gql`
    fragment AiExchangeAttachment on AiExchangeAttachment {
  id
  libraryItem {
    ...ChatAttachmentLibraryItem
  }
  media {
    ...ChatAttachmentMedia
  }
}
    ${ChatAttachmentLibraryItemFragmentDoc}
${ChatAttachmentMediaFragmentDoc}`;
export const VercelAiChatAnnotationFragmentDoc = gql`
    fragment VercelAiChatAnnotation on VercelAiChatAnnotation {
  type
  file_id
  filename
  quote
  index
  metadata
}
    `;
export const VercelAiChatMessageFragmentDoc = gql`
    fragment VercelAiChatMessage on VercelAiChatMessage {
  id
  role
  content
  annotations {
    ...VercelAiChatAnnotation
  }
  createdAt
}
    ${VercelAiChatAnnotationFragmentDoc}`;
export const AiChatExchangeFragmentDoc = gql`
    fragment AiChatExchange on AiChatExchange {
  id
  createdAt
  attachments {
    ...AiExchangeAttachment
  }
  vercelChatMessages {
    ...VercelAiChatMessage
  }
}
    ${AiExchangeAttachmentFragmentDoc}
${VercelAiChatMessageFragmentDoc}`;
export const AiChatFragmentDoc = gql`
    fragment AiChat on AiChat {
  id
  title
  createdAt
  type
  exchanges {
    ...AiChatExchange
  }
}
    ${AiChatExchangeFragmentDoc}`;
export const ChatAttachMenuLibraryItemsDocument = gql`
    query ChatAttachMenuLibraryItems($input: AdminLibraryInput!, $pagination: PaginationInput) {
  AdminLibrary(input: $input, pagination: $pagination) {
    objects {
      ...ChatAttachmentLibraryItem
    }
  }
}
    ${ChatAttachmentLibraryItemFragmentDoc}`;

/**
 * __useChatAttachMenuLibraryItemsQuery__
 *
 * To run a query within a React component, call `useChatAttachMenuLibraryItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatAttachMenuLibraryItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatAttachMenuLibraryItemsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useChatAttachMenuLibraryItemsQuery(baseOptions: Apollo.QueryHookOptions<ChatAttachMenuLibraryItemsQuery, ChatAttachMenuLibraryItemsQueryVariables> & ({ variables: ChatAttachMenuLibraryItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChatAttachMenuLibraryItemsQuery, ChatAttachMenuLibraryItemsQueryVariables>(ChatAttachMenuLibraryItemsDocument, options);
      }
export function useChatAttachMenuLibraryItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChatAttachMenuLibraryItemsQuery, ChatAttachMenuLibraryItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChatAttachMenuLibraryItemsQuery, ChatAttachMenuLibraryItemsQueryVariables>(ChatAttachMenuLibraryItemsDocument, options);
        }
export type ChatAttachMenuLibraryItemsQueryHookResult = ReturnType<typeof useChatAttachMenuLibraryItemsQuery>;
export type ChatAttachMenuLibraryItemsLazyQueryHookResult = ReturnType<typeof useChatAttachMenuLibraryItemsLazyQuery>;
export type ChatAttachMenuLibraryItemsQueryResult = Apollo.QueryResult<ChatAttachMenuLibraryItemsQuery, ChatAttachMenuLibraryItemsQueryVariables>;
export const ChatHistoryDocument = gql`
    query ChatHistory($input: MyAiChatsInput!, $pagination: PaginationInput) {
  MyAiChats(input: $input, pagination: $pagination) {
    objects {
      ...AiChat
    }
    totalCount
  }
}
    ${AiChatFragmentDoc}`;

/**
 * __useChatHistoryQuery__
 *
 * To run a query within a React component, call `useChatHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatHistoryQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useChatHistoryQuery(baseOptions: Apollo.QueryHookOptions<ChatHistoryQuery, ChatHistoryQueryVariables> & ({ variables: ChatHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChatHistoryQuery, ChatHistoryQueryVariables>(ChatHistoryDocument, options);
      }
export function useChatHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChatHistoryQuery, ChatHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChatHistoryQuery, ChatHistoryQueryVariables>(ChatHistoryDocument, options);
        }
export type ChatHistoryQueryHookResult = ReturnType<typeof useChatHistoryQuery>;
export type ChatHistoryLazyQueryHookResult = ReturnType<typeof useChatHistoryLazyQuery>;
export type ChatHistoryQueryResult = Apollo.QueryResult<ChatHistoryQuery, ChatHistoryQueryVariables>;
export const GenCourseFromOutlineChatDocument = gql`
    mutation GenCourseFromOutlineChat($input: GenCourseFromOutlineChatInput!) {
  genCourseFromOutlineChat(input: $input) {
    success
    error {
      code
    }
    course {
      id
      draftVersion {
        id
      }
      libraryItem {
        id
      }
    }
  }
}
    `;
export type GenCourseFromOutlineChatMutationFn = Apollo.MutationFunction<GenCourseFromOutlineChatMutation, GenCourseFromOutlineChatMutationVariables>;

/**
 * __useGenCourseFromOutlineChatMutation__
 *
 * To run a mutation, you first call `useGenCourseFromOutlineChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenCourseFromOutlineChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [genCourseFromOutlineChatMutation, { data, loading, error }] = useGenCourseFromOutlineChatMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenCourseFromOutlineChatMutation(baseOptions?: Apollo.MutationHookOptions<GenCourseFromOutlineChatMutation, GenCourseFromOutlineChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenCourseFromOutlineChatMutation, GenCourseFromOutlineChatMutationVariables>(GenCourseFromOutlineChatDocument, options);
      }
export type GenCourseFromOutlineChatMutationHookResult = ReturnType<typeof useGenCourseFromOutlineChatMutation>;
export type GenCourseFromOutlineChatMutationResult = Apollo.MutationResult<GenCourseFromOutlineChatMutation>;
export type GenCourseFromOutlineChatMutationOptions = Apollo.BaseMutationOptions<GenCourseFromOutlineChatMutation, GenCourseFromOutlineChatMutationVariables>;
export const StartGenCourseFromOutlineChatWorkflowDocument = gql`
    mutation StartGenCourseFromOutlineChatWorkflow($input: GenCourseFromOutlineChatInput!) {
  startGenCourseFromOutlineChatWorkflow(input: $input) {
    success
    error {
      code
    }
    clientFacingWorkflow {
      id
      type
      status
      createdAt
      result {
        id
        libraryItem {
          id
          name {
            uuid
            en
          }
        }
      }
    }
  }
}
    `;
export type StartGenCourseFromOutlineChatWorkflowMutationFn = Apollo.MutationFunction<StartGenCourseFromOutlineChatWorkflowMutation, StartGenCourseFromOutlineChatWorkflowMutationVariables>;

/**
 * __useStartGenCourseFromOutlineChatWorkflowMutation__
 *
 * To run a mutation, you first call `useStartGenCourseFromOutlineChatWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartGenCourseFromOutlineChatWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startGenCourseFromOutlineChatWorkflowMutation, { data, loading, error }] = useStartGenCourseFromOutlineChatWorkflowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartGenCourseFromOutlineChatWorkflowMutation(baseOptions?: Apollo.MutationHookOptions<StartGenCourseFromOutlineChatWorkflowMutation, StartGenCourseFromOutlineChatWorkflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartGenCourseFromOutlineChatWorkflowMutation, StartGenCourseFromOutlineChatWorkflowMutationVariables>(StartGenCourseFromOutlineChatWorkflowDocument, options);
      }
export type StartGenCourseFromOutlineChatWorkflowMutationHookResult = ReturnType<typeof useStartGenCourseFromOutlineChatWorkflowMutation>;
export type StartGenCourseFromOutlineChatWorkflowMutationResult = Apollo.MutationResult<StartGenCourseFromOutlineChatWorkflowMutation>;
export type StartGenCourseFromOutlineChatWorkflowMutationOptions = Apollo.BaseMutationOptions<StartGenCourseFromOutlineChatWorkflowMutation, StartGenCourseFromOutlineChatWorkflowMutationVariables>;
export const StartGenModuleFromOutlineChatWorkflowDocument = gql`
    mutation StartGenModuleFromOutlineChatWorkflow($input: GenModuleFromOutlineChatInput!) {
  startGenModuleFromOutlineChatWorkflow(input: $input) {
    success
    error {
      code
    }
    clientFacingWorkflow {
      id
      type
      status
      createdAt
      result {
        id
        libraryItem {
          id
          name {
            uuid
            en
          }
        }
      }
    }
  }
}
    `;
export type StartGenModuleFromOutlineChatWorkflowMutationFn = Apollo.MutationFunction<StartGenModuleFromOutlineChatWorkflowMutation, StartGenModuleFromOutlineChatWorkflowMutationVariables>;

/**
 * __useStartGenModuleFromOutlineChatWorkflowMutation__
 *
 * To run a mutation, you first call `useStartGenModuleFromOutlineChatWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartGenModuleFromOutlineChatWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startGenModuleFromOutlineChatWorkflowMutation, { data, loading, error }] = useStartGenModuleFromOutlineChatWorkflowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartGenModuleFromOutlineChatWorkflowMutation(baseOptions?: Apollo.MutationHookOptions<StartGenModuleFromOutlineChatWorkflowMutation, StartGenModuleFromOutlineChatWorkflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartGenModuleFromOutlineChatWorkflowMutation, StartGenModuleFromOutlineChatWorkflowMutationVariables>(StartGenModuleFromOutlineChatWorkflowDocument, options);
      }
export type StartGenModuleFromOutlineChatWorkflowMutationHookResult = ReturnType<typeof useStartGenModuleFromOutlineChatWorkflowMutation>;
export type StartGenModuleFromOutlineChatWorkflowMutationResult = Apollo.MutationResult<StartGenModuleFromOutlineChatWorkflowMutation>;
export type StartGenModuleFromOutlineChatWorkflowMutationOptions = Apollo.BaseMutationOptions<StartGenModuleFromOutlineChatWorkflowMutation, StartGenModuleFromOutlineChatWorkflowMutationVariables>;
export const StartGenTaskListFromOutlineChatWorkflowDocument = gql`
    mutation StartGenTaskListFromOutlineChatWorkflow($input: GenTaskListFromOutlineChatInput!) {
  startGenTaskListFromOutlineChatWorkflow(input: $input) {
    success
    error {
      code
    }
    clientFacingWorkflow {
      id
      type
      status
      createdAt
      result {
        id
        libraryItem {
          id
          name {
            uuid
            en
          }
        }
      }
    }
  }
}
    `;
export type StartGenTaskListFromOutlineChatWorkflowMutationFn = Apollo.MutationFunction<StartGenTaskListFromOutlineChatWorkflowMutation, StartGenTaskListFromOutlineChatWorkflowMutationVariables>;

/**
 * __useStartGenTaskListFromOutlineChatWorkflowMutation__
 *
 * To run a mutation, you first call `useStartGenTaskListFromOutlineChatWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartGenTaskListFromOutlineChatWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startGenTaskListFromOutlineChatWorkflowMutation, { data, loading, error }] = useStartGenTaskListFromOutlineChatWorkflowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartGenTaskListFromOutlineChatWorkflowMutation(baseOptions?: Apollo.MutationHookOptions<StartGenTaskListFromOutlineChatWorkflowMutation, StartGenTaskListFromOutlineChatWorkflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartGenTaskListFromOutlineChatWorkflowMutation, StartGenTaskListFromOutlineChatWorkflowMutationVariables>(StartGenTaskListFromOutlineChatWorkflowDocument, options);
      }
export type StartGenTaskListFromOutlineChatWorkflowMutationHookResult = ReturnType<typeof useStartGenTaskListFromOutlineChatWorkflowMutation>;
export type StartGenTaskListFromOutlineChatWorkflowMutationResult = Apollo.MutationResult<StartGenTaskListFromOutlineChatWorkflowMutation>;
export type StartGenTaskListFromOutlineChatWorkflowMutationOptions = Apollo.BaseMutationOptions<StartGenTaskListFromOutlineChatWorkflowMutation, StartGenTaskListFromOutlineChatWorkflowMutationVariables>;
export const StartGenCheckInFromOutlineChatWorkflowDocument = gql`
    mutation StartGenCheckInFromOutlineChatWorkflow($input: GenCheckInFromOutlineChatInput!) {
  startGenCheckInFromOutlineChatWorkflow(input: $input) {
    success
    error {
      code
    }
    clientFacingWorkflow {
      id
      type
      status
      createdAt
      result {
        id
        libraryItem {
          id
          name {
            uuid
            en
          }
        }
      }
    }
  }
}
    `;
export type StartGenCheckInFromOutlineChatWorkflowMutationFn = Apollo.MutationFunction<StartGenCheckInFromOutlineChatWorkflowMutation, StartGenCheckInFromOutlineChatWorkflowMutationVariables>;

/**
 * __useStartGenCheckInFromOutlineChatWorkflowMutation__
 *
 * To run a mutation, you first call `useStartGenCheckInFromOutlineChatWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartGenCheckInFromOutlineChatWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startGenCheckInFromOutlineChatWorkflowMutation, { data, loading, error }] = useStartGenCheckInFromOutlineChatWorkflowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartGenCheckInFromOutlineChatWorkflowMutation(baseOptions?: Apollo.MutationHookOptions<StartGenCheckInFromOutlineChatWorkflowMutation, StartGenCheckInFromOutlineChatWorkflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartGenCheckInFromOutlineChatWorkflowMutation, StartGenCheckInFromOutlineChatWorkflowMutationVariables>(StartGenCheckInFromOutlineChatWorkflowDocument, options);
      }
export type StartGenCheckInFromOutlineChatWorkflowMutationHookResult = ReturnType<typeof useStartGenCheckInFromOutlineChatWorkflowMutation>;
export type StartGenCheckInFromOutlineChatWorkflowMutationResult = Apollo.MutationResult<StartGenCheckInFromOutlineChatWorkflowMutation>;
export type StartGenCheckInFromOutlineChatWorkflowMutationOptions = Apollo.BaseMutationOptions<StartGenCheckInFromOutlineChatWorkflowMutation, StartGenCheckInFromOutlineChatWorkflowMutationVariables>;
export const StartGenAuditFromOutlineChatWorkflowDocument = gql`
    mutation StartGenAuditFromOutlineChatWorkflow($input: GenAuditFromOutlineChatInput!) {
  startGenAuditFromOutlineChatWorkflow(input: $input) {
    success
    error {
      code
    }
    clientFacingWorkflow {
      id
      type
      status
      createdAt
      result {
        id
        libraryItem {
          id
          name {
            uuid
            en
          }
        }
      }
    }
  }
}
    `;
export type StartGenAuditFromOutlineChatWorkflowMutationFn = Apollo.MutationFunction<StartGenAuditFromOutlineChatWorkflowMutation, StartGenAuditFromOutlineChatWorkflowMutationVariables>;

/**
 * __useStartGenAuditFromOutlineChatWorkflowMutation__
 *
 * To run a mutation, you first call `useStartGenAuditFromOutlineChatWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartGenAuditFromOutlineChatWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startGenAuditFromOutlineChatWorkflowMutation, { data, loading, error }] = useStartGenAuditFromOutlineChatWorkflowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartGenAuditFromOutlineChatWorkflowMutation(baseOptions?: Apollo.MutationHookOptions<StartGenAuditFromOutlineChatWorkflowMutation, StartGenAuditFromOutlineChatWorkflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartGenAuditFromOutlineChatWorkflowMutation, StartGenAuditFromOutlineChatWorkflowMutationVariables>(StartGenAuditFromOutlineChatWorkflowDocument, options);
      }
export type StartGenAuditFromOutlineChatWorkflowMutationHookResult = ReturnType<typeof useStartGenAuditFromOutlineChatWorkflowMutation>;
export type StartGenAuditFromOutlineChatWorkflowMutationResult = Apollo.MutationResult<StartGenAuditFromOutlineChatWorkflowMutation>;
export type StartGenAuditFromOutlineChatWorkflowMutationOptions = Apollo.BaseMutationOptions<StartGenAuditFromOutlineChatWorkflowMutation, StartGenAuditFromOutlineChatWorkflowMutationVariables>;